import { find } from "lodash/fp";

import ROUTES from "@app/common/routes";
import type { EntityAccessLevel } from "@app/common/types";
import { getAppUrl } from "@app/utils/utils";

export const ACCESS_LEVELS: {
  label: string;
  value: EntityAccessLevel;
  description: string;
  deprecated?: boolean;
}[] = [
  {
    label: "Viewer - Recap Only",
    value: "viewer_recap_only",
    description:
      "Can view and download the meeting recap with summary and basic details",
    deprecated: true,
  },
  {
    label: "Viewer",
    value: "viewer_full",
    description:
      "Can view and download the detailed meeting report and metrics",
  },
  {
    label: "Editor",
    value: "editor",
    description:
      "Can view the full report, edit the notes and transcript, download, and share",
  },
];

const ALL_ACCESS_LEVELS = [
  {
    label: "Owner",
    value: "owner",
    description: "Has owner access to the report",
  },
  ...ACCESS_LEVELS,
];

export const getAccessLevel = (accessLevel: EntityAccessLevel) =>
  find({ value: accessLevel }, ALL_ACCESS_LEVELS)!;

export const canEdit = (accessLevel?: EntityAccessLevel) =>
  accessLevel === "owner" || accessLevel === "editor";

export const isMeetingOwner = (accessLevel?: EntityAccessLevel) =>
  accessLevel === "owner";

export const hasRecapOnlyAccess = (accessLevel?: EntityAccessLevel) =>
  accessLevel === "viewer_recap_only";

export const isForbidden = (accessLevel?: EntityAccessLevel) =>
  accessLevel === "forbidden" || accessLevel === "no_access";

export const canShareReport = (accessLevel?: EntityAccessLevel) =>
  canEdit(accessLevel);

export const getReportShareLink = (
  sessionId: string,
  source: "nav" | "share"
): string => {
  return getAppUrl(
    `${ROUTES.meetingReportById(sessionId)}?utm_source=${
      source === "share" ? "Share_CopyLink" : "Share_Nav"
    }`
  );
};

export default { canShareReport };
